<template>
    <div class="personalInformation">
        <div class="outer-border">
            <div class="b-title title-border-bottom">个人信息</div>
            <div class="tabs">
                <div class="tab-w">
                    <div class="tab tab1" :class="active?'active':''" @click="activeTab(!active)">手机验证修改</div>
                    <div class="tab tab2" :class="active?'':'active'" @click="activeTab(!active)">邮箱验证修改</div>
                </div>
            </div>
            <el-row>
                <el-form
                    :model="userInfo"
                    ref="userInfo"
                    label-width="100px"
                    class="demo-form clearfix"
                    :rules="rules"
                >
                    <el-col :span="18">
                        <div class="grid-content bg-purple">
                            <el-form-item label="昵称:" prop="username">
                                <el-input
                                    size="small"
                                    v-model="userInfo.username"
                                    placeholder="请输入昵称..."
                                     maxlength="20"
                                    show-word-limit
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="真实姓名:" prop="realName">
                                <el-input
                                    size="small"
                                    v-model="userInfo.realName"
                                    placeholder="请输入真实姓名..."
                                     maxlength="20"
                                    show-word-limit
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="身份证号:" prop="idCard">
                                <el-input
                                    size="small"
                                    v-model="userInfo.idCard"
                                    placeholder="请输入身份证号..."
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="邮箱:" prop="email" v-if="!active">
                                <el-input
                                    size="small"
                                    v-model="userInfo.email"
                                    placeholder="请输入邮箱..."
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="手机号:" prop="phone" v-if="active">
                                <el-input
                                    size="small"
                                    v-model="userInfo.phone"
                                    placeholder="请输入手机号..."
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="验证码:" prop="temp" >
                                <el-input placeholder="验证码" v-model="userInfo.temp" class="yzm">
                                    <el-button
                                        slot="append"
                                        :disabled="disabledyzm"
                                        @click="yxGetYZM()"
                                    >{{btntxt}}</el-button>
                                    <!-- <template slot="append" @click="getYZM()">获取</template> -->
                                </el-input>
                            </el-form-item>
                            <el-row class="text-center">
                                <el-col :span="24">
                                    <el-button
                                        type="danger"
                                        @click="submitForm('userInfo')"
                                        class="btn red"
                                    >保存</el-button>
                                    <!-- <el-button
                                        type="primary"
                                        @click="resetForm()"
                                        class="btn blue"
                                    >取消</el-button>-->
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                     
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item class="headImg">
                                <el-upload
                                    class="avatar-uploader"
                                    :headers="{
                                        'Authentication-Token':token,
                                        'Authentication-Platform':0,
                                        'Authentication-DeviceId':deviceId
                                    }"
                                    :action="myFileUrl+'user/editHeadImg'"
                                    :data="{id:userInfo.id,headImg:userInfo.headImg}"
                                    :show-file-list="false"
                                    :on-success="(res, file) => handleAvatarSuccess(res, file, 'headImg')"
                                    :before-upload="beforeAvatarUpload"
                                >
                                    <img
                                        v-if="userInfo.headImg"
                                        :src="$store.state.imgUrl+userInfo.headImg"
                                        class="avatar"
                                    />
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <span>头像</span>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-form>
            </el-row>
        </div>
    </div>
</template>

<script>
import rules from "@/common/rules";

export default {
    name: "personalInformation",
    data() {
        return {
            token:'',
            deviceId:'',
            active:true,
            rules: {
                username:[
                    {
                        required: true,
                        message: "请输入昵称",
                        trigger: "blur"
                    }
                ],
                realName:[
                    {
                        required: true,
                        message: "请输入真实姓名",
                        trigger: "blur"
                    }
                ],
                temp:[
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur"
                    }
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入手机号",
                        trigger: "blur"
                    },
                    {
                        validator: rules.FormValidate.Form().validatePhoneForm,
                        trigger: ["blur", "change"]
                    }
                ],
                idCard: [
                    {
                        required: true,
                        message: "请输入身份证号",
                        trigger: "blur"
                    },
                    {
                        validator: rules.FormValidate.Form().IDForm,
                        trigger: "blur"
                    }
                ],
                email: [
                    {
                        required: true,
                        message: "请输入邮箱",
                        trigger: "blur"
                    },
                    {
                        validator: rules.FormValidate.Form().validateEmail,
                        trigger: ["blur", "change"]
                    }
                ]
            },
            userInfo:{},
            time: 60,
            btntxt: "获取验证码",
            disabledyzm: false,
            timerId:null
        };
    },
    methods: {
        activeTab(active){
            this.active = active;
            clearTimeout(this.timerId);
            this.timerId = null;
            this.time= 60;
            this.btntxt= "获取验证码";
            this.disabledyzm= false;
        },
        //文件上传的格式判断
        beforeAvatarUpload(file) {
            const isLt1M = file.size / 1024 / 1024 < 1;
            const isJPG = file.type === "image/jpeg";
            const isPNG = file.type === "image/png";
            if (!isLt1M) {
                this.$message.error("上传图片大小不能超过 1MB!");
            }
            if (!isJPG && !isPNG) {
                this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
            }
            return (isJPG || isPNG) && isLt1M;
        },
        //上传成功
        handleAvatarSuccess(res, file, k) {
            let that = this;
            this.$set(this.userInfo,k,res.data.headImg)
            // this.userInfo[k] = res.data.headImg;
            if (res.code == 200) {
                that.$message.success("上传成功");
            } else {
                that.$message.error("上传失败");
            }
        },
        //个人信息回显
        infoDisplay(id) {
            let that = this;
            let url = "user/get";
            let params = {
                id: id
            };
            that.$http
                .post(url, params)
                .then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        that.userInfo = res.data;
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(() => {
                });
        },
        submitForm(formName) {
            let that = this;
            this.$refs[formName].validate(async valid => {
                if (!valid) return;
                let url = "user/editUser";
                let params ={
                    username: that.userInfo.username,
                    realName:that.userInfo.realName,
                    idCard:that.userInfo.idCard,
                    temp:that.userInfo.temp,
                    phone:that.userInfo.phone,
                    email:that.userInfo.email
                };

                if(that.active){
                    //手机验证
                    params.validType = 2;
                }else{
                    //邮箱验证
                    params.validType = 1;
                }
                that.$http
                    .post(url, params)
                    .then(res => {
                        res = res.data;
                        if (res.code == 200) {
                            that.$message({
                                type: "success",
                                message: "保存成功!"
                            });
                            this.infoDisplay(this.userInfo.id);
                            if (sessionStorage.getItem("userInfo")) {
                                let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
                                userInfo.id = res.data.id;
                                userInfo.email = res.data.email;
                                userInfo.phone = res.data.phone;
                                userInfo.username = res.data.username;
                                userInfo.realName = res.data.realName;
                                userInfo.idCard = res.data.idCard;
                                sessionStorage.setItem("userInfo",JSON.stringify(userInfo));
                                 // 刷新兄弟组件
                                 let NewPage =
                                    "_empty" +
                                    "?time=" +
                                    new Date().getTime() / 500;
                                this.$router.push(NewPage);
                                this.$router.go(-1);
                            }
                            
                        } else {
                            that.$message.error(res.msg);
                        }
                    })
                    .catch(() => {
                    });
            });
        },
        // 获取验证码
        yxGetYZM() {
            let that = this;
            if(that.active){
                //手机验证
                if (!that.userInfo.phone) {
                    that.$message.error("请先输入手机号");
                    return false;
                }
                let url = "/user/phone/sendCodeToPhoneAccount";
                    let params = {
                        phone: that.userInfo.phone
                    };
                    that.$http
                        .post(url, params)
                        .then(res => {
                    if (res.data.code == 200) {
                        that.disabledyzm = true;
                        that.timeryzm();
                        that.$message({
                            message: "验证码发送成功",
                            type: "success"
                        });
                    } else {
                        that.$message.error(res.data.msg);
                    }
                })
                .catch(() => {});
            }else{
                //邮箱验证
                if (!that.userInfo.email) {
                    that.$message.error("请先输入邮箱");
                    return false;
                }
                let url = "/user/sendCodeToEmail";
                    let params = {
                        email: that.userInfo.email
                    };
                    that.$http
                        .post(url, params)
                        .then(res => {
                    if (res.data.code == 200) {
                        that.disabledyzm = true;
                        that.timeryzm();
                        that.$message({
                            message: "验证码发送成功",
                            type: "success"
                        });
                    } else {
                        that.$message.error(res.data.msg);
                    }
                })
                .catch(() => {});
            }
       
           
        },
         //多少秒后重新获取验证码
         timeryzm() {
            if (this.time > 0) {
                this.time--;
                // console.log(this.time);
                this.btntxt = this.time + "s";
                 // 存储 setTimeout 的返回值
                this.timerId =setTimeout(this.timeryzm, 1000);
            } else {
                this.time = 60;
                this.btntxt = "重新获取";
                this.disabledyzm = false;
            }
        },

        // resetForm(formName) {
        //     this.$refs[formName].validate(valid => {
        //         if (valid) {
        //             alert("submit!");
        //         } else {
        //             console.log("error submit!!");
        //             return false;
        //         }
        //     });
        // }
    },
    created() {
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            this.infoDisplay(this.userInfo.id);
        }
         if (sessionStorage.getItem("token")) {
            this.token = sessionStorage.getItem("token");
        }
         if (sessionStorage.getItem("deviceId")) {
            this.deviceId = sessionStorage.getItem("deviceId");
        }
        
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.demo-form {
    width: 60%;
    margin: 0 auto;
    margin-top: 39px;
    margin-bottom: 40px;
}
.demo-form .el-input {
    width: 230px;
}
.demo-form .el-form-item {
    display: inline-block;
}
.avatar-uploader {
    width: 120px;
    height: 120px;
    line-height: 120px;
    border: 1px solid #ddd;
    text-align: center;
    vertical-align: middle;
    border-radius: 50%;
}
.outer-border {
    min-height: 528px;
}
.avatar {
    width: 120px;
    height: 120px;
    border-radius: 50%;
}
.tabs{
    display: flex;
    justify-content: center;
    height: 40px;
    line-height: 40px;
    margin-top: 20px;
  
}
.tabs .tab-w{
    display: flex;
    border-bottom: 1px solid #ddd;
}
.tab-w .tab1{
    margin-right: 40px;
}
.tab-w .tab{
    font-weight: 600;
    font-size: 16px;
    color: #aaa;
    cursor: pointer;
}
.tab-w .active{
    border-bottom: 3px solid #f64420 ;
    color: #f64420;
}
</style>



// WEBPACK FOOTER //
// src/components/JW/personalInformation.vue